module.exports = __webpack_public_path__ + "static/media/item_6_16_comp.1bd8174e.png";